<template>
  <div>
    <detected/>
    <!-- <p class="splitline"></p> -->
    <!-- 聊天+用户 -->
    <div class="chatAndUser-container">
      <div style="padding: 10px;">
        <ul class="chatUserTab">
          <li
            v-for="(t, index) in tabList"
            :key="index"
            :class="{ 'chatUserTab-active': tabActice == t.type }"
            class="pointer"
            @click="changeChatUserTab(t.type)"
            v-if="t.show"
          >
          <span class="at_sign" v-if="t.type == 0 && atLists > 0">@</span>
          {{$t(`asideRight.${t.name}`)}}<i class="dot-answer" v-if="t.type == 2 && dot"></i>
            <span v-if="t.type == 1 && hostUsersShow"
              >（{{ userAllNumber }}）</span
            >
            <span class="at_sign_num" v-if="t.type == 0 && atLists > 0">{{ atLists }}</span>
          </li>
        </ul>
      </div>

      <!-- 聊天区域 -->
      <chatRoomArea ref="chatArea" v-show="tabActice == 0" :show="tabActice"></chatRoomArea>
      <!-- 用户列表区域 -->
      <userListArea
        v-show="tabActice == 1"
        :phoneControlUrl="phoneControlUrl"
        :phoneReadonlyUrl="phoneReadonlyUrl"
      ></userListArea>
      <!--问答区域-->
      <answer v-show="tabActice == 2" ref="answer" :show="tabActice == 2"/>
    </div>
    <!-- <rewardList :reward="showRewardList" @totalWard="totalWard" ref="reward" /> -->
  </div>
</template>

<script>
import chatRoomArea from "@/components/chatroom";
import userListArea from "@/components/onLineUserList";
import detected from "@/components/detected/index.vue";
import { getWebcastCount } from "@/api/liveRequest/chatApi";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
import { getPhoneConnectInfo } from "@/api/liveRequest/login";
import answer from "@/components/askAnswer" 
import Bus from "@/components/doc/bus";

export default {
  name: "asideRight",
  components: {
    chatRoomArea,
    userListArea,
    detected,
    answer
  },
  data() {
    return {
      tabActice: 0,
      tabList: [
        { name: "聊天", type: 0, show: true},
        { name: "问答", type: 2, show: false},
        { name: "用户", type: 1, show: true},
      ],
      showRewardList: false,
      praiseCount: 0,
      rewardCount: 0,
      userNumber: 0,
      phoneControlUrl: null,
      phoneReadonlyUrl: null,
      atLists: 0,
      dot: false,
    };
  },
  watch: {
    tabActice(val) {
      if (val === 0) {
        this.$nextTick(() => {
          this.$refs.chatArea.scrollBottom(true);
        });
      }
      // if(val === 2){
      //   this.$nextTick(() => {
      //     this.$refs.answer.scrollToBottom();
      //   });
      // }
    },
    curAvctl(info, old) {
      if (!old && info) {
        console.log(info.name, "进入提示。。。。。。。。");
        let role = info.type == 3 ? this.$t('aside-right.主播') : info.type == 2 ? this.$t('aside-right.助手') : this.$t('aside-right.嘉宾');
        if (info.type == 3) return;
        this.$message.success(`${role}_${info.name}${this.$t('aside-right.成为了管理员')}`);
        Bus.$emit("systemMsg", {
          role: role,
          name: info.name,
          text: '成为了管理员'
        });
      }
    },
    curShare(info, old) {
      console.log(old, "演示权改变old");
      console.log(info, "演示权改变info");
      if (!old && info) {
        let role = info.type == 3 ? this.$t('aside-right.主播') : info.type == 2 ? this.$t('aside-right.助手') : this.$t('aside-right.嘉宾');
        if (info.type != 3) {
          this.$message.success(`${role}_${info.name}${this.$t('aside-right.正在演示')}`);
        }
        Bus.$emit("systemMsg", {
          role: role,
          name: info.name,
          text: '正在演示'
        });
      }
    },
    liveToken: {
      immediate: true,
      handler(value) {
        console.log(value, "token");
        this.getPhoneConnect();
      },
    },
    qaEnabled:{
      immediate: true,
      handler(value) {
        console.log(value, "qaEabled")
        if(value){
        this.tabList[1].show = true;
      }
      },
    }
    
  },
  beforeDestroy() {
    Bus.$off("systemMsg");
    Bus.$off("atMsgLength")
  },
  computed: {
    qaEnabled(){
      return this.$store.getters.qaEnabled;
    },
    guestSeeAuth() {
      return this.$store.getters.guestSeeAuth;
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.type
      );
    },
    joinedListLength() {
      return (
        this.$store.getters.JoinedList &&
        this.$store.getters.JoinedList.filter((info) => {
          return info.type != undefined;
        }).length
      );
    },
    curAvctl() {
      return (
        this.$store.getters.JoinedList &&
        this.$store.getters.JoinedList.find((info) => {
          return info.avctl == 1;
        })
      );
    },
    curShare() {
      return (
        this.$store.getters.JoinedList &&
        this.$store.getters.JoinedList.find((info) => {
          return info.share == 1;
        })
      );
    },
    userAllNumber() {
      if (this.role != 1 || this.guestSeeAuth != 2) {
        return this.userNumber + this.joinedListLength;
      } else {
        return this.joinedListLength;
      }
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    hostUsersShow() {
      return this.$store.state.liveInfo.liveConfig.is_host_users_show;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      Bus.$on("changeUserNum", (info) => {
        // console.log(info, "info number");
        // console.log(this.joinedListLength, "this.joinedListLength");
        this.userNumber = info;
        this.$store.commit("SET_USERNUMBER", info);
      });
      Bus.$on("atMsgLength",num => {
        if(this.tabActice !== 0) {
          this.atLists = num;
        } else {
          this.atLists = 0;
        }
      });
      Bus.$on("dot", info => {
        // if(this.tabActice !== 2) {
        //   this.dot = true;
        // } else {
          this.dot = info;
        // }
      });
    },
    changeChatUserTab(type) {
      this.tabActice = type;
      if(type === 2) {
        // let clientHeight = this.$refs.answer.$refs.scrollRef?.wrap.clientHeight;
        // let scrollTop = this.$refs.answer.$refs.scrollRef?.wrap.scrollTop;
        // let scrollHeight = this.$refs.answer.$refs.scrollRef?.wrap.scrollHeight;
        // // console.log(clientHeight,"clientHeight");
        // console.log(scrollHeight,"scrollHeight");
        // console.log(scrollTop,"scrollTop");
        //if(Math.ceil(scrollTop + clientHeight) <= scrollHeight) {
        //this.dot = false;
        //}
        Bus.$emit("refreshAskList");
      }
    },
    getWebcastCount() {
      getWebcastCount({ webcastId: this.$route.query.liveId }, this.liveToken)
        .then((res) => {
          if (res.code === 200) {
            this.praiseCount = res.data.praiseCount;
            this.$store.commit("SET_PRAISECOUNT", this.praiseCount);
          }
        })
        .catch((err) => {
          console.log(err, "err_getWebcastCount");
        });
    },
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
      }
    },
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "praise":
            this.praiseCount = requestData.praiseCount;
            this.$store.commit("SET_PRAISECOUNT", this.praiseCount);
            break;
          case "qa/webcast_config":
            this.tabActice = 0;
            this.tabList[1].show = requestData.switchType?true: false;
          // case "giftEvent":
          //   if (requestData.price !== "0") {
          //     this.$refs.reward.rewardslists();
          //   }
          //   break;
          // case "assistant_user_join_leave_state":{
          //     let userMsg =
          //     (requestData &&
          //       requestData.message &&
          //       JSON.parse(requestData.message)) ||
          //     requestData;
          //   if (userMsg.status == "join" && userMsg.role != 5) return;
          //   if (userMsg) {
          //      if (userMsg.status == "join") {
          //          this.userNumber++
          //      }else if(userMsg.status == "leave"){
          //           this.userNumber--
          //      }
          //   }
          // }

          //   break;
        }
      }
    },
    totalWard(total) {
      this.rewardCount = total > 0 ? (total / 100).toFixed(2) : 0;
      this.$store.commit("SET_REWARDCOUNT", this.rewardCount);
    },
    getPhoneConnect() {
      getPhoneConnectInfo(this.liveToken).then((res) => {
        if (res && res.code == 200) {
          this.phoneControlUrl = res.data.data.secHostUrl;
          this.phoneReadonlyUrl = res.data.data.secGuestUrl;
        }
      });
    },
  },
  mounted() {
    pushRoomMessageFunc((msg) => {
      this.getCvMcRoomMessage(msg);
    });
  },
};
</script>

<style  scoped lang="scss">
@import "@/assets/styles/vars";
.chatAndUser-container {
  height: 100%;
  background-color: $chatuserbg-color;
  border-top: 1px solid #292c51;
  box-sizing: border-box;
  .chatUserTab {
    width: 280px;
    display: flex;
    background-color: $chatusertabbg-color;
    margin: auto;
    height: 38px;
    border-radius: 6px;
    > li {
      width: 50%;
      display: inline-block;
      line-height: 38px;
      font-size: 14px;
      color: $chatusertabfont-color;
      position: relative;
    }
    .chatUserTab-active {
      color: $white-color;
      background-color: $chatusertabactivebg-color;
      border-radius: 6px;
    }
  }
}
.splitline {
  height: 1px;
  background-color: $splitline-color;
}
.at_sign_num{
  width: 23px;
    height: 16px;
    line-height: 16px;
    background: #EA494B;
    border-radius: 8px;
    color: #FFFFFF;
    font-size: 12px;
    position: absolute;
    display: inline-block;
    right: 2px;
    top: 2px;
}
.at_sign{
  width: 14px;
    height: 14px;
    border-radius: 1px;
    display: inline-block;
    line-height: 14px;
    color: #FF595B;
    font-size: 14px;
}
.dot-answer {
  width: 6px;
  height: 6px;
  background: #FF595B;
  border-radius: 7px;
  display: inline-block;
  position: absolute;
  top: 10px;
  right: 28px;
}
</style>
